import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, hasMany, references } from '@apexdesigner/schema-tools';

export const processInstance = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    referenceNumber: z
      .number()
      .nullable()
      .optional()
      .describe('Human-readable reference number'),

    name: z
      .string()
      .nullable()
      .optional()
      .describe('Optional name to identify this instance'),

    status: z
      .enum(['Active', 'Paused', 'Terminated', 'Complete', 'Error'])
      .nullable()
      .optional()
      .describe('Current state of this instance'),

    data: z
      .unknown()
      .nullable()
      .optional()
      .presentAs('json')
      .describe('Process data and variable values'),

    errorMessage: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Error details if the instance failed'),

    claimedBy: z
      .string()
      .nullable()
      .optional()
      .hidden()
      .describe('Server node processing this instance'),

    claimedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When processing started on this instance'),

    completedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this instance finished'),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('createdAt'),

    updatedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('updatedAt'),

    processDesignId: z.uuid().hidden().describe('Foreign key to ProcessDesign'),

    parentTokenId: z
      .uuid()
      .nullable()
      .optional()
      .hidden()
      .describe('Foreign key to Token'),

    processDesign: belongsTo('ProcessDesign'),

    parentToken: references('Token', 'parentTokenId'),

    processInstanceHistories: hasMany(
      'ProcessInstanceHistory',
      'processInstanceId',
    ),

    pendingStateUpdates: hasMany('PendingStateUpdate', 'processInstanceId'),

    tokens: hasMany('Token', 'processInstanceId'),

    callingTokens: hasMany('Token', 'currentChildProcessInstanceId'),
  })
  .describe('A running instance of a process design')
  .as('ProcessInstance');

export { processInstance as processInstanceSchema };
